
    <div class="ui-button-with-label {{additionalClass}}">
      <p-button [icon]="icon" [styleClass]="styleClass" (onClick)="click($event)"></p-button>
      <span class="ui-button-with-label__label">{{label}}</span>
    </div>
  